import { ModalOverlay } from '../components/ModalOverlay.js';

export function ExtendRequestPrompt({ minutes, onRespond }: { minutes: number; onRespond: (accept: boolean) => void }) {
  return (
    <ModalOverlay className="z-50 bg-black/60">
      <div className="card p-6 max-w-sm w-full text-center text-ink-900 dark:text-ink-100">
        <h2 className="h-card mb-1">Extend the session?</h2>
        <p className="hint mb-4">The learner is requesting <span className="font-semibold">{minutes} more minutes</span>.</p>
        <div className="flex gap-2 justify-center">
          <button type="button" className="btn" onClick={() => onRespond(false)}>Decline</button>
          <button type="button" className="btn-primary" onClick={() => onRespond(true)}>Accept</button>
        </div>
      </div>
    </ModalOverlay>
  );
}
